import { Button as MuiButton, SxProps } from '@mui/material'

interface ButtonProps {
  label?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  disabled?: boolean
  variant?: 'text' | 'contained' | 'outlined'
  startIcon?: React.ReactNode
  type?: 'submit'
  color?:
    | 'success'
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'warning'
  className?: string
  sx?: SxProps
}

const Button = ({
  label,
  onClick,
  disabled,
  variant,
  startIcon,
  color,
  type,
  className,
  sx,
}: ButtonProps) => {
  return (
    <MuiButton
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      startIcon={startIcon}
      color={color}
      type={type}
      className={className}
      sx={sx}
    >
      {label}
    </MuiButton>
  )
}

export default Button
